import { useAppSelector } from 'reduxTyped'
import { Ability } from 'common/core/constants/Ability'
import { getManyAbilities } from 'common/core/selectors/abilitiesSelectors'

/**
 * Works the same way as `useAbility`, but with given many abilities.
 * @see `useAbility`
 *
 * @example
 * const [channelsCountAbility, smsChannelAbility] = useAbilities([
 *   Ability.CHANNELS_COUNT,
 *   Ability.SMS_CHANNEL
 * ] as const)
 * const newChannelDisabled = channelsCountAbility.limit === channelsCountAbility.used
 * const isSmsChannelAvailable = smsChannelAbility.isEnabled
 *
 */
export function useAbilities<Abilities extends Readonly<Ability[]>>(abilities: Abilities) {
  return useAppSelector((state) => getManyAbilities(state, abilities))
}
